import { render, staticRenderFns } from "./LockScreenAddNfcBadgeModal.vue?vue&type=template&id=5375121d&scoped=true"
import script from "./LockScreenAddNfcBadgeModal.vue?vue&type=script&lang=ts"
export * from "./LockScreenAddNfcBadgeModal.vue?vue&type=script&lang=ts"
import style0 from "./LockScreenAddNfcBadgeModal.vue?vue&type=style&index=0&id=5375121d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5375121d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5375121d')) {
      api.createRecord('5375121d', component.options)
    } else {
      api.reload('5375121d', component.options)
    }
    module.hot.accept("./LockScreenAddNfcBadgeModal.vue?vue&type=template&id=5375121d&scoped=true", function () {
      api.rerender('5375121d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/LockScreenAddNfcBadgeModal.vue"
export default component.exports